import React, { useState, useEffect, useRef } from 'react';
import { XPGainData } from '../services/WebSocketService';
import webSocketService from '../services/WebSocketService';
import soundService from '../services/SoundService';
import XPText from './XPText';

interface XPTextItem {
  id: string;
  amount: number;
  x: number;
  y: number;
  createdAt: number; // Add timestamp for safety cleanup
}

const XPManager: React.FC = () => {
  const [xpTexts, setXpTexts] = useState<XPTextItem[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Handler for XP gain events
    const handleXPGain = (data: XPGainData) => {
      // Add a small random offset to avoid overlapping texts
      const randomOffsetX = Math.random() * 20 - 10; // -10 to +10
      

      // Create a new XP text item with random ID
      const newItem: XPTextItem = {
        id: Math.random().toString(36).substring(2, 9),
        amount: data.amount,
        x: 300+randomOffsetX,
        y: 50, //data.position.y + randomOffsetY - 50, // Start higher above the object
        createdAt: Date.now()
      };
      
      console.log(newItem)

      // Add to the list of active XP texts
      setXpTexts(prev => [...prev, newItem]);
      
      // Play XP gain sound
      soundService.playXPGainSound();
    };
    
    // Register the XP gain callback
    webSocketService.onXPGain(handleXPGain);
    
    // Set up safety cleanup interval to remove any stuck XP texts
    const cleanupInterval = setInterval(() => {
      const now = Date.now();
      // Remove any texts older than 2 seconds (animation is 1.5 seconds, so this gives extra 0.5s buffer)
      setXpTexts(prev => prev.filter(item => now - item.createdAt < 300));
    }, 500);
    
    // Clean up on unmount
    return () => {
      // No need for explicit cleanup as the WebSocketService is a singleton
      clearInterval(cleanupInterval);
    };
  }, []);
  
  // Handler for when an XP text animation completes
  const handleAnimationComplete = (id: string) => {
    setXpTexts(prev => prev.filter(item => item.id !== id));
  };
  
  return (
    <div ref={containerRef} className="absolute inset-0 pointer-events-none overflow-hidden">
      {xpTexts.map(item => (
        <XPText
          key={item.id}
          xpValue={item.amount}
          positionX={item.x}
          positionY={item.y}
          onAnimationComplete={() => handleAnimationComplete(item.id)}
        />
      ))}
    </div>
  );
};

export default XPManager; 